import { h } from 'preact';
export const Rewind = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polygon", { points: "11 19 2 12 11 5 11 19" }),
        h("polygon", { points: "22 19 13 12 22 5 22 19" })));
};
//# sourceMappingURL=rewind.js.map